<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="'保证金金额'" prop="amount">
                <a-input v-model="queryParam.amount" :placeholder="'请输入保证金金额'" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="'状态'" prop="status">
                <a-select v-model="queryParam.status" :placeholder="'请选择状态'" allow-clear>
                  <a-select-option :value="1">{{ '启用' }}</a-select-option>
                  <a-select-option :value="0">{{ '禁用' }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery">
                  <a-icon type="search" />
                  {{ '查询' }}
                </a-button>
                <a-button style="margin-left: 8px" @click="resetQuery">
                  <a-icon type="redo" />
                  {{ '重置' }}
                </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()">
          <a-icon type="plus" />
          {{ '新增' }}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)">
          <a-icon type="edit" />
          {{ '修改' }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete">
          <a-icon type="delete" />
          {{ '删除' }}
        </a-button>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="amount" slot-scope="text, record">
          {{ text }}
        </span>
        <span slot="dailyWithdrawLimit" slot-scope="text, record">
          {{ text }}
        </span>
        <span slot="sortNum" slot-scope="text, record">
          {{ text }}
        </span>
        <span slot="status" slot-scope="text, record">
          <a-tag v-if="text === 1" color="green">{{ $t('启用') }}</a-tag>
          <a-tag v-else color="red">{{ $t('禁用') }}</a-tag>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(text) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['shop:deposit:config:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)">
            <a-icon type="edit" />
            {{ '修改' }}
          </a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record)">
            <a-icon type="delete" />
            {{ '删除' }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {
  pageShopDepositConfig,
  delShopDepositConfig
} from '@/api/shop/shopDepositConfig'
import CreateForm from './CreateForm'

export default {
  name: 'ShopDepositConfig',
  components: {
    CreateForm
  },
  data() {
    return {
      // 列表数据
      list: [],
      total: 0,
      loading: false,
      // 查询参数
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        amount: undefined,
        status: undefined
      },
      // 表格设置
      tableSize: 'default',
      tableBordered: false,
      advanced: false,
      pageSizeOptions: ['10', '20', '30', '50', '100'],
      // 列设置
      columns: [
        {
          title: '保证金金额',
          dataIndex: 'amount',
          ellipsis: true,
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'amount' }
        },
        {
          title: '最高日提现额度',
          dataIndex: 'dailyWithdrawLimit',
          ellipsis: true,
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'dailyWithdrawLimit' }
        },
        {
          title: '排序号',
          dataIndex: 'sortNum',
          ellipsis: true,
          align: 'center',
          width: 100,
          scopedSlots: { customRender: 'sortNum' }
        },
        {
          title: '状态',
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          width: 100,
          scopedSlots: { customRender: 'status' }
        },
        // {
        //   title: '创建时间',
        //   dataIndex: 'createTime',
        //   ellipsis: true,
        //   align: 'center',
        //   width: 180,
        //   scopedSlots: { customRender: 'createTime' }
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          ellipsis: true,
          align: 'center',
          fixed: 'right',
          width: 200,
          scopedSlots: { customRender: 'operation' }
        }
      ],
      // 选中行
      selectedRowKeys: [],
      selectedRows: [],
      ids: [],
      single: true,
      multiple: false
    }
  },
  created() {
    this.getList()
  },
  methods: {
    /** 查询列表 */
    getList() {
      this.loading = true
      pageShopDepositConfig(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 查询按钮 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        amount: undefined,
        status: undefined
      }
      this.handleQuery()
    },
    /** 表格排序变化 */
    handleSortChange(pagination, filters, sorter) {
      if (sorter.column) {
        this.queryParam.orderByColumn = sorter.field
        this.queryParam.isAsc = sorter.order === 'ascend' ? 1 : 0
        this.getList()
      }
    },
    /** 表格选中变化 */
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    /** 删除按钮 */
    handleDelete(row) {
      const ids = row.id ? [row.id] : this.ids
      const that = this
      this.$confirm({
        title: '确认删除',
        content: '是否删除选中数据',
        onOk() {
          delShopDepositConfig(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功')
          })
        }
      })
    },
    /** 分页 */
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.queryParam.pageNum = 1
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    parseTime(time) {
      return this.$moment(time).format('YYYY-MM-DD HH:mm:ss')
    },
    getTotal(total) {
      return '共 ' + total + ' 条'
    }
  }
}
</script>

<style scoped>
</style>
